import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { FileUploader } from "react-drag-drop-files";
import React, { useState, useEffect } from "react";
import XMLParser from "react-xml-parser";
import { useSiteDataApi } from "../utilities/SiteDataProvider";
import Cookies from "universal-cookie";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AppBar from "@mui/material/AppBar";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import ReturnModal from "./sections/ReturnModal";
import EditModal from "./sections/EditModal";

const comparisonLabels = {
  healthNumber: "Health Card Number",
  firstName: "First Name",
  lastName: "Last Name",
  dateOfBirth: "Date of Birth",
};

const HEALTHCARD_CODES_URL = `${process.env.PUBLIC_URL}/HCV/healthcard-codes.pdf`;

const cookies = new Cookies();

const adminUsers = [
  "True Hearing Health",
  "Taylor Field",
  "Brian Field",
  "TrueHearing%20Health",
  "TrueHearing Health",
];

(function () {
  if (typeof Object.defineProperty === "function") {
    try {
      Object.defineProperty(Array.prototype, "sortBy", { value: sb });
    } catch (e) {}
  }
  if (!Array.prototype.sortBy) Array.prototype.sortBy = sb;

  function sb(f) {
    for (var i = this.length; i; ) {
      var o = this[--i];
      this[i] = [].concat(f.call(o, o, i), o);
    }
    this.sort(function (a, b) {
      for (var i = 0, len = a.length; i < len; ++i) {
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
      }
      return 0;
    });
    for (i = this.length; i; ) {
      this[--i] = this[i][this[i].length - 1];
    }
    return this;
  }
})();

function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      className="tabpanelmark"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
    key: index,
  };
}
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

let formatPhoneNumber = (str) => {
  //Filter only numbers from the input
  let cleaned = ("" + str).replace(/\D/g, "");

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }

  return null;
};
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// (Reverted fuzzy matching helper)

const ADPTracker = () => {
  const fileTypes = ["XML"];
  const [value, setValue] = React.useState(
    parseInt(cookies.get("activeClinic")) || 0,
  );
  let fileReader;
  const [hasError, setHasError] = useState([]);
  const [firstRun, setFirstRun] = useState(true);
  const [fileName, setFileName] = useState();
  const [renameWarning, setRenameWarning] = useState();
  const [ctrlKeyHeld, setCtrlKeyHeld] = useState(false);
  const [file, setFile] = useState();
  const [XMLFile, setXMLFile] = useState();
  const [parsingFile, setParsingFile] = useState(false);
  const [XMLDetails, setXMLDetails] = useState({});
  const [hcvStatus, setHcvStatus] = useState("");
  const [hcvDetails, setHcvDetails] = useState(null);
  const [submitResult, setSubmitResult] = useState("");
  const [username, setUsername] = useState("contact@truehearinghealth.com");
  const [password, setPassword] = useState("XLwzxiK25v6*44K");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [editOpen, setEditOpen] = React.useState(false);
  const [ADPeditDetails, setADPeditDetails] = useState(null);
  const [editIsPaid, setEditIsPaid] = useState(false);
  const handleEditOpen = () => setEditOpen(true);
  const handleEditClose = () => {
    setEditOpen(false);
    setADPeditDetails(null);
    // Refresh data so new _adp_status entries ("Edit - ...") appear immediately
    fetchADPdata();
  };

  // Edit history modal state
  const [editHistoryOpen, setEditHistoryOpen] = useState(false);
  const [editHistoryDetail, setEditHistoryDetail] = useState(null);

  // BP documents confirmation modal state
  const [bpConfirmOpen, setBpConfirmOpen] = useState(false);
  const [bpAttestationChecked, setBpAttestationChecked] = useState(false);
  const [bpApplicationChecked, setBpApplicationChecked] = useState(false);
  const pendingSubmitEvent = React.useRef(null);

  // (Audiogram check runs inline during file parse)
  const [audiogramData, setAudiogramData] = useState([]);

  // Track if we've already fetched BP data to prevent duplicate calls
  const hasFetchedBPData = React.useRef(false);

  // Track Ctrl key for admin override
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Control") {
        setCtrlKeyHeld(true);
      }
    };
    const handleKeyUp = (e) => {
      if (e.key === "Control") {
        setCtrlKeyHeld(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const getHcvSeverity = (statusText) => {
    if (!statusText) return "info";
    if (statusText.startsWith("✅")) return "success";
    if (statusText.startsWith("⚠️")) return "warning";
    if (statusText.startsWith("❌")) return "error";
    // Special case: if the message contains "passed validation" but also mentions a notice/warning
    if (
      statusText.includes("passed validation") &&
      statusText.toLowerCase().includes("did not respond")
    ) {
      return "warning";
    }
    return "info";
  };

  const getSubmitSeverity = (message) => {
    if (!message) return "info";
    const lowered = message.toLowerCase();
    if (lowered.includes("error") || lowered.includes("failed")) {
      return "error";
    }
    if (lowered.includes("warning")) {
      return "warning";
    }
    if (lowered.includes("please upload")) {
      return "warning";
    }
    return "success";
  };

  const normalizeDate = (value) => {
    if (!value) return "";
    // Remove timestamp portion (T00:00:00.000-05:00) if present
    const dateOnly = String(value).split("T")[0];
    const digits = dateOnly.replace(/\D/g, "");
    if (digits.length === 8) {
      return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(
        6,
        8,
      )}`;
    }
    return dateOnly;
  };

  const buildExpectedValue = (field) => {
    switch (field) {
      case "healthNumber":
        return XMLDetails?.healthNumber || "";
      case "firstName":
        return (XMLDetails?.applicantFirstname || "").toUpperCase();
      case "lastName":
        return (XMLDetails?.applicantLastname || "").toUpperCase();
      case "dateOfBirth":
        return normalizeDate(XMLDetails?.date_of_birth || "");
      default:
        return "";
    }
  };

  const buildActualValue = (field) => {
    const result = hcvDetails?.result || {};
    switch (field) {
      case "firstName": {
        // Return exactly what MOH returned in the firstName field
        return (result.firstName || "").toUpperCase();
      }
      case "lastName":
        return (result.lastName || "").toUpperCase();
      case "dateOfBirth":
        return normalizeDate(result.dateOfBirth || "");
      case "healthNumber":
        return result.healthNumber || "";
      default:
        return "";
    }
  };

  const normalizeForComparison = (value) => {
    if (value === null || value === undefined) {
      return "";
    }
    return String(value).trim();
  };

  const evaluateFieldMatch = (field, expectedValue, actualValue) => {
    const normalizedExpected = normalizeForComparison(expectedValue);
    const normalizedActual = normalizeForComparison(actualValue);

    if (!normalizedExpected && !normalizedActual) {
      return undefined;
    }

    const valuesEqual = normalizedExpected === normalizedActual;
    const rawMatch = hcvDetails?.matches?.[field];

    if (rawMatch === false) {
      return false;
    }

    if (rawMatch === true) {
      return valuesEqual;
    }

    if (typeof rawMatch === "string") {
      const normalizedFlag = rawMatch.trim().toLowerCase();
      if (["false", "0", "no", "n", "mismatch"].includes(normalizedFlag)) {
        return false;
      }
      if (["true", "1", "yes", "y", "match"].includes(normalizedFlag)) {
        return valuesEqual;
      }
    }

    return valuesEqual;
  };

  const renderComparisonRow = (field) => {
    const label = comparisonLabels[field];
    if (!label) return null;

    const expectedValue = buildExpectedValue(field);
    const actualValue = buildActualValue(field);
    const match = evaluateFieldMatch(field, expectedValue, actualValue);

    if (!expectedValue && !actualValue) {
      return null;
    }

    const color =
      match === undefined
        ? "text.primary"
        : match
          ? "success.main"
          : "error.main";
    const matchText = match === undefined ? "" : match ? "Match" : "Mismatch";

    return (
      <Box key={field} mb={0.75}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Expected: {expectedValue || "n/a"}
        </Typography>
        <Typography variant="body2" color={color}>
          Actual: {actualValue || "n/a"}
          {matchText ? ` (${matchText})` : ""}
        </Typography>
      </Box>
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    cookies.set("activeClinic", newValue, {
      path: "/",
      secure: true,
      sameSite: "none",
    });
  };
  const handleFileRead = (e) => {
    const content = fileReader.result;

    setHasError([]);
    // console.log('wee', parseString(content));
    var xml = new XMLParser().parseFromString(content); // Assume xmlText contains the example XML
    setXMLFile(content);
    const section1 = xml.children[0].children[2].children;
    const section2 = xml.children[0].children[3].children;
    const section3 = xml.children[0].children[4].children;
    const section4 = xml.children[0].children[5].children;
    const adpForm = section1.concat(section2).concat(section3).concat(section4);
    const parsedDetails = {};

    console.log("adpForm", adpForm);

    const allowEmptyFields = [
      "applicantMiddleinitial",
      "streetNo",
      "nameLTCH",
      "unitNo",
      "rrRoute",
      "busPhone",
      "phoneExtension",
      "confirmationOfBenefit",
      "hearingAids",
      "other",
      "reason",
      "confirmation",
      "sig",
      "contact",
      "homePhone",
      "authorizer",
      "vendor",
      "equipmentSpec",
      "proofOfDelivery",
    ];
    let emptyhomePhone = false;

    let sigCol = [];
    let agentApplying = false;
    setFirstRun(false);
    let ADPportion = 0;
    let docSigDate = "";
    let patFinalSigDate = "";
    // strict date format regex for YYYY/MM/DD used across validations
    const dateRegEx = /^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/;

    adpForm.map((field) => {
      //empty phone numbers
      if (field.value === "" && field.name === "homePhone") {
        emptyhomePhone = true;
      }

      if (field.name === "applicantFirstname" && field.value !== "") {
        parsedDetails.applicantFirstname = field.value;
        setXMLDetails((prevState) => ({
          ...prevState,
          applicantFirstname: field.value,
        }));
      }
      if (field.name === "applicantLastname" && field.value !== "") {
        parsedDetails.applicantLastname = field.value;
        setXMLDetails((prevState) => ({
          ...prevState,
          applicantLastname: field.value,
        }));
      }
      if (field.name === "vendor" && field.children[11].value !== "") {
        setXMLDetails((prevState) => ({
          ...prevState,
          invoiceNo: field.children[11].value,
        }));
      }

      if (field.name === "homePhone" && field.value !== "") {
        setXMLDetails((prevState) => ({
          ...prevState,
          phone: field.value,
        }));
      }
      if (field.name === "DateOfBirth" && field.value !== "") {
        parsedDetails.date_of_birth = field.value;
        setXMLDetails((prevState) => ({
          ...prevState,
          date_of_birth: field.value,
        }));
      }
      if (field.name === "healthNo" && field.value !== "") {
        parsedDetails.healthNumber = field.value.replace(/\D/g, "");
        parsedDetails.healthcard_four = field.value.substring(6, 10);
        setXMLDetails((prevState) => ({
          ...prevState,
          healthNumber: field.value.replace(/\D/g, ""),
          healthcard_four: field.value.substring(6, 10),
        }));
      }
      if (field.name === "homePhone" && field.value === "") {
        setHasError((hasError) => [...hasError, `Home phone is empty `]);
      }
      if (field.name === "homePhone" && field.value !== "") {
        const v = field.value.trim();
        // Check for invalid characters
        if (!/^[\d\s()+-]+$/.test(v)) {
          setHasError((prev) => [
            ...prev,
            `"homePhone" contains invalid characters. Only digits, spaces, parentheses, "+" and "-" are allowed.`,
          ]);
        }
        // Check for correct number of digits (should be 10 digits)
        const digitsOnly = v.replace(/\D/g, "");
        if (digitsOnly.length !== 10) {
          setHasError((prev) => [
            ...prev,
            `"homePhone" must contain exactly 10 digits. Found ${digitsOnly.length} digits.`,
          ]);
        }
      }
      if (
        field.name === "healthNo" &&
        field.value.match(/[0-9]{10}/g) === null
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Healthcard is not correct format (10 digits)`,
        ]);
      }
      if (
        field.name === "versionNo" &&
        field.value.match(/[A-Z]{2}/g) === null
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Healthcard version code is not correct format (2 letters)`,
        ]);
      }
      if (field.name === "versionNo" && field.value !== "") {
        parsedDetails.versionCode = field.value.trim().toUpperCase();
        setXMLDetails((prevState) => ({
          ...prevState,
          versionCode: field.value.trim().toUpperCase(),
        }));
      }
      // 1) If this node _is_ a busPhone, validate its value:
      if (field.name === "busPhone") {
        const v = field.value.trim();
        if (v && !/^[\d\s()+-]+$/.test(v)) {
          setHasError((prev) => [
            ...prev,
            `“busPhone” in section1 (or wherever) contains invalid characters. Only digits, spaces, parentheses, “+” and “-” are allowed.`,
          ]);
        }
        if (v) {
          const digitsOnly = v.replace(/\D/g, "");
          if (digitsOnly.length !== 10) {
            setHasError((prev) => [
              ...prev,
              `“busPhone” must contain exactly 10 digits. Found ${digitsOnly.length} digits.`,
            ]);
          }
        }
      }
      // 2) If this node has any children named “busPhone” (e.g. audiologist, authorizer, vendor, contact):
      if (field.children && field.children.length) {
        field.children
          .filter((child) => child.name === "busPhone")
          .forEach((child) => {
            const v = child.value.trim();
            if (v && !/^[\d\s()+-]+$/.test(v)) {
              // child under field.name has bad chars
              setHasError((prev) => [
                ...prev,
                `${
                  field.name.charAt(0).toUpperCase() + field.name.slice(1)
                } business phone contains invalid characters. Only digits, spaces, parentheses, “+” and “-” are allowed.`,
              ]);
            }
            if (v) {
              const digitsOnly = v.replace(/\D/g, "");
              if (digitsOnly.length !== 10) {
                setHasError((prev) => [
                  ...prev,
                  `${
                    field.name.charAt(0).toUpperCase() + field.name.slice(1)
                  } business phone must contain exactly 10 digits. Found ${
                    digitsOnly.length
                  } digits.`,
                ]);
              }
            }
          });
      }

      // 2a) If this node has any children named "homePhone" (e.g. contact):
      if (field.children && field.children.length) {
        field.children
          .filter((child) => child.name === "homePhone")
          .forEach((child) => {
            const v = child.value.trim();
            if (v) {
              // Check for invalid characters
              if (!/^[\d\s()+-]+$/.test(v)) {
                setHasError((prev) => [
                  ...prev,
                  `${
                    field.name.charAt(0).toUpperCase() + field.name.slice(1)
                  } home phone contains invalid characters. Only digits, spaces, parentheses, "+" and "-" are allowed.`,
                ]);
              }
              // Check for correct number of digits (should be 10 digits)
              const digitsOnly = v.replace(/\D/g, "");
              if (digitsOnly.length !== 10) {
                setHasError((prev) => [
                  ...prev,
                  `${
                    field.name.charAt(0).toUpperCase() + field.name.slice(1)
                  } home phone must contain exactly 10 digits. Found ${
                    digitsOnly.length
                  } digits.`,
                ]);
              }
            }
          });
      }

      if (
        field.value === "" &&
        field.name === "busPhone" &&
        emptyhomePhone === true
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Home phone and business phone cannot both be empty.`,
        ]);
      }
      //confirmation of benefits
      if (field.name === "confirmationOfBenefit") {
        if (
          field.children[0].value === "yes" &&
          field.children[1].value === ""
        ) {
          setHasError((hasError) => [
            ...hasError,
            `If patient is receiving social benefits must check which program on page 1.`,
          ]);
        }
      }
      if (field.name === "confirmationOfBenefit") {
        if (field.children[0].value === "") {
          setHasError((hasError) => [
            ...hasError,
            `Missing check for confirmation of benefits on page 1.`,
          ]);
        }
        if (
          field.children[2].value === "" ||
          field.children[2].value === "yes"
        ) {
          setHasError((hasError) => [
            ...hasError,
            `Problem with WSIB Checkbox on page 1.`,
          ]);
        }
        if (
          field.children[3].value === "" ||
          field.children[2].value === "yes"
        ) {
          setHasError((hasError) => [
            ...hasError,
            `Problem with VAC Checkbox on page 1.`,
          ]);
        }
      }

      //broad empty field check
      if (field.value === "" && !allowEmptyFields.includes(field.name)) {
        setHasError((hasError) => [
          ...hasError,
          `${field.name} cannot be empty.`,
        ]);
      }

      //reason for application
      if (field.name === "reason") {
        if (
          field.children[0].children[0].value === "" &&
          field.children[0].children[2].value === ""
        ) {
          setHasError((hasError) => [
            ...hasError,
            `Reason for application is missing on page 2.`,
          ]);
        }
        if (
          field.children[0].children[0].value !== "" &&
          field.children[0].children[2].value !== ""
        ) {
          setHasError((hasError) => [
            ...hasError,
            `Both 'first access' and 'replacement' should not be checked on page 2.`,
          ]);
        }
        // if field.children[1].children[1].value
        // field.children[1].children[2].value

        if (
          (field.children[0].children[0].value === "firstAccess" &&
            field.children[1].children[0].value !== "") ||
          (field.children[0].children[0].value === "firstAccess" &&
            field.children[1].children[1].value !== "") ||
          (field.children[0].children[0].value === "firstAccess" &&
            field.children[1].children[2].value !== "")
        ) {
          setHasError((hasError) => [
            ...hasError,
            `If first access, replacement boxes shouldn't be checked on page 2.`,
          ]);
        }
        if (field.children[1].children[2].value) {
        }
        if (field.children[0].children[2].value === "replacement") {
          console.log("got replacement");
          if (
            field.children[1].children[1].value === "normalWear" &&
            field.children[1].children[2].value !== "vendorQuote"
          ) {
            setHasError((hasError) => [
              ...hasError,
              `If reason for application is replacement, 'normal wear' and 'vendor quote' boxes must both be checked on page 2.`,
            ]);
          }
          if (
            field.children[1].children[1].value !== "normalWear" &&
            field.children[1].children[2].value === "vendorQuote"
          ) {
            setHasError((hasError) => [
              ...hasError,
              `If reason for application is replacement, 'normal wear' and 'vendor quote' boxes must both be checked on page 2.`,
            ]);
          }
          if (
            field.children[1].children[1].value !== "" &&
            field.children[1].children[0].value !== ""
          ) {
            setHasError((hasError) => [
              ...hasError,
              `Only 1 replacement reason should be checked on page 2.`,
            ]);
          }
        }
      }
      //agent is applying
      if (field.name === "sig" && field.children[1].value === "agent") {
        agentApplying = true;
      }
      if (agentApplying === true && field.name === "contact") {
        if (
          field.children[0].value === "" ||
          field.children[1].value === "" ||
          field.children[2].value === "" ||
          field.children[5].value === "" ||
          field.children[6].value === "" ||
          field.children[8].value === "" ||
          field.children[9].value === "" ||
          field.children[10].value === "" ||
          (field.children[11].value === "" && field.children[12].value === "")
        ) {
          setHasError((hasError) => [
            ...hasError,
            `Agent details or relationship is missing on page 3.`,
          ]);
        }
      }

      //check type of aid checked
      let noaids = true;
      if (field.name === "hearingAids") {
        field.children.forEach((aid) => {
          if (aid.value !== "") {
            noaids = false;
          }
        });
        if (noaids === true) {
          setHasError((hasError) => [
            ...hasError,
            `No hearing device types are checked on the bottom of page 1`,
          ]);
        }
      }

      //patient sig date one
      if (field.name === "sig" && field.children[2].value !== "") {
        sigCol.push({
          name: "1st Patient signature",
          page: 3,
          date: field.children[2].value,
        });
      }
      //empty patient signature one
      if (field.name === "sig" && field.children[1].value === "") {
        setHasError((hasError) => [
          ...hasError,
          `Applicant vs. Agent checkbox missing on page 3.`,
        ]);
      }

      //patient sig date missing one
      if (field.name === "sig" && field.children[2].value === "") {
        setHasError((hasError) => [
          ...hasError,
          `Patient signature date on page 3 is missing.`,
        ]);
      }
      //invalid patient sig
      if (
        field.name === "sig" &&
        isNaN(Date.parse(field.children[2].value)) === true
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Patient signature date on page 3 is invalid.`,
        ]);
      }
      if (
        field.name === "sig" &&
        isNaN(Date.parse(field.children[2].value)) === false
      ) {
        let patientSigDateTemp = Date.parse(field.children[2].value);
        let todays_date = new Date().getTime();
        let diff = todays_date - patientSigDateTemp;
        let diffDays = Math.floor(diff / 1000 / 60 / 60 / 24);
        if (todays_date - patientSigDateTemp < 0 || diffDays > 365) {
          setHasError((hasError) => [
            ...hasError,
            `Patient signature date on page 3 is more than 365 days in the past or is in the future or invalid.`,
          ]);
        }
      }
      //patient sig date Two
      if (field.name === "proofOfDelivery" && field.children[1].value !== "") {
        sigCol.push({
          name: "2nd Patient signature",
          page: 5,
          date: field.children[1].value,
        });
      }
      //empty patient signature Two
      if (field.name === "proofOfDelivery" && field.children[1].value === "") {
        setHasError((hasError) => [
          ...hasError,
          `Patient signature (Proof of delivery) Date missing on page 5.`,
        ]);
      }
      //invalid patient sig two
      if (
        field.name === "proofOfDelivery" &&
        isNaN(Date.parse(field.children[1].value)) === true
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Patient signature (proof of delivery) date on page 5 is invalid.`,
        ]);
      }
      if (
        field.name === "proofOfDelivery" &&
        isNaN(Date.parse(field.children[1].value)) === false
      ) {
        let patientSigDateTemp = Date.parse(field.children[1].value);
        let todays_date = new Date().getTime();
        let diff = todays_date - patientSigDateTemp;
        let diffDays = Math.floor(diff / 1000 / 60 / 60 / 24);
        if (todays_date - patientSigDateTemp < 0 || diffDays > 365) {
          setHasError((hasError) => [
            ...hasError,
            `Patient signature date on page 5 is more than 365 days in the past or is in the future or invalid.`,
          ]);
        }
      }
      //empty vendor reg number

      if (field.name === "vendor" && field.children[2].value === "") {
        setHasError((hasError) => [
          ...hasError,
          `Vendor Registration Number is missing.`,
        ]);
      }
      //vendor attestation must be 'yes'
      if (field.name === "vendor") {
        const attestation = (field.children[0].value || "")
          .trim()
          .toLowerCase();
        if (attestation !== "yes") {
          setHasError((hasError) => [
            ...hasError,
            `Vendor Attestation is required and must be 'yes'. Found: '${field.children[0].value || ""}'.`,
          ]);
        }
      }
      //vendor sig date (push only if format is valid)
      if (
        field.name === "vendor" &&
        field.children[10].value !== "" &&
        dateRegEx.test(field.children[10].value) === true
      ) {
        sigCol.push({
          name: "Vendor signature",
          page: 4,
          date: field.children[10].value,
        });
      }
      //empty vendor signature
      if (field.name === "vendor" && field.children[10].value === "") {
        setHasError((hasError) => [
          ...hasError,
          `Vendor signature Date missing on page 4.`,
        ]);
      }
      //invalid vendor signature date format
      if (
        field.name === "vendor" &&
        field.children[10].value !== "" &&
        dateRegEx.test(field.children[10].value) === false
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Vendor signature date must be in YYYY/MM/DD format (e.g., 2025/07/28).`,
        ]);
      }

      //invalid vendor sig
      if (
        field.name === "vendor" &&
        dateRegEx.test(field.children[10].value) === true &&
        isNaN(Date.parse(field.children[10].value)) === true
      ) {
        setHasError((hasError) => [
          ...hasError,
          `vendor signture date on page 4 is invalid.`,
        ]);
      }
      if (
        field.name === "vendor" &&
        dateRegEx.test(field.children[10].value) === true &&
        isNaN(Date.parse(field.children[10].value)) === false
      ) {
        let patientSigDateTemp = Date.parse(field.children[10].value);
        let todays_date = new Date().getTime();
        let diff = todays_date - patientSigDateTemp;
        let diffDays = Math.floor(diff / 1000 / 60 / 60 / 24);
        if (todays_date - patientSigDateTemp < 0 || diffDays > 365) {
          setHasError((hasError) => [
            ...hasError,
            `vendor signature date on page 4 is more than 365 days in the past or is in the future or invalid.`,
          ]);
        }
      }
      //clinician adpNum
      if (field.name === "authorizer" && field.children[4].value === "") {
        setHasError((hasError) => [
          ...hasError,
          `Clinician ADP number is missing. Check it is the correct clinician. (Clinician: ${field.children[1].value} ${field.children[0].value})`,
        ]);
      }
      //provider (authorizer) signature date handling (strict format)
      if (
        field.name === "authorizer" &&
        field.children &&
        field.children.length >= 7
      ) {
        const provDate = field.children[6].value || "";
        if (provDate !== "" && dateRegEx.test(provDate) === true) {
          sigCol.push({
            name: "Clinician signature",
            page: 4,
            date: provDate,
          });
        }
        if (provDate === "") {
          setHasError((hasError) => [
            ...hasError,
            `Clinician signature Date missing on page 4.`,
          ]);
        }
        if (provDate !== "" && dateRegEx.test(provDate) === false) {
          setHasError((hasError) => [
            ...hasError,
            `Clinician signature date must be in YYYY/MM/DD format (e.g., 2025/07/28).`,
          ]);
        }
        if (provDate !== "" && dateRegEx.test(provDate) === true) {
          if (isNaN(Date.parse(provDate)) === true) {
            setHasError((hasError) => [
              ...hasError,
              `clinician sig date on page 4 is invalid.`,
            ]);
          } else {
            let patientSigDateTemp = Date.parse(provDate);
            let todays_date = new Date().getTime();
            let diff = todays_date - patientSigDateTemp;
            let diffDays = Math.floor(diff / 1000 / 60 / 60 / 24);
            if (todays_date - patientSigDateTemp < 0 || diffDays > 365) {
              setHasError((hasError) => [
                ...hasError,
                `clinician sig date on page 4 is more than 365 days in the past or is in the future or invalid.`,
              ]);
            }
          }
        }
      }
      //empty invoice number
      if (field.name === "vendor" && field.children[11].value === "") {
        setHasError((hasError) => [
          ...hasError,
          `Invoice number is empty on page 4`,
        ]);
      }
      //empty sides
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[0].children[0].value === "" &&
        field.children[0].children[0].children[1].value === "" &&
        field.children[0].children[0].children[2].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 1 on Page 5 must have a side`,
        ]);
      }
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[1].children[0].value === "" &&
        field.children[0].children[1].children[1].value === "" &&
        field.children[0].children[1].children[2].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 2 on Page 5 must have a side`,
        ]);
      }
      //empty serial numbers
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[0].children[4].value !== "" &&
        field.children[0].children[0].children[5].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 1 serial number is missing on Page 5`,
        ]);
      }
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[1].children[4].value !== "" &&
        field.children[0].children[1].children[5].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 2 serial number is missing on Page 5`,
        ]);
      }
      //empty ADP portion or client portion when serial number is present
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[0].children[5].value !== "" &&
        field.children[0].children[0].children[6].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 1 ADP portion (Cell4) is missing on Page 5`,
        ]);
      }
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[0].children[5].value !== "" &&
        field.children[0].children[0].children[7].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 1 client portion (Cell5) is missing on Page 5`,
        ]);
      }
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[1].children[5].value !== "" &&
        field.children[0].children[1].children[6].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 2 ADP portion (Cell4) is missing on Page 5`,
        ]);
      }
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[1].children[5].value !== "" &&
        field.children[0].children[1].children[7].value === ""
      ) {
        setHasError((hasError) => [
          ...hasError,
          `Device 2 client portion (Cell5) is missing on Page 5`,
        ]);
      }

      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[0].children[6].value !== ""
      ) {
        ADPportion =
          ADPportion +
          parseFloat(field.children[0].children[0].children[6].value);
      }
      if (
        field.name === "equipmentSpec" &&
        field.children[0].children[1].children[6].value !== ""
      ) {
        ADPportion =
          ADPportion +
          parseFloat(field.children[0].children[1].children[6].value);
      }

      if (field.name === "vendor" && field.children[8].value !== "") {
        if (field.children[8].value.includes("London")) {
          console.log("ADP address is London, logging in with contact@");
          setUsername("contact@truehearinghealth.com");
          setPassword("vACEb%p6Uw!hy*3");
          field.children[2].value = "2021516";
        }
        if (field.children[8].value.includes("Sarnia")) {
          console.log("ADP address is Sarnia, logging in with contact+sarnia@");
          setUsername("contact+sarnia@truehearinghealth.com");
          setPassword("sk8D!@gqSc%T9t6");
          field.children[2].value = "2024740";
        }
        if (field.children[8].value.includes("Chatham")) {
          console.log(
            "ADP address is Chatham, logging in with contact+chatham@",
          );
          setUsername("contact+chatham@truehearinghealth.com");
          setPassword("a4z3Nv!ZK#d$gQG45");
          field.children[2].value = "2022610";
        }
        if (field.children[8].value.includes("Windsor")) {
          console.log(
            "ADP address is Windsor, logging in with contact+windsor@",
          );
          setUsername("contact+windsor@truehearinghealth.com");
          setPassword("l*zNLLn%z4g$A2k8");
          field.children[2].value = "2023678";
        }
        if (field.children[8].value.includes("Brantford")) {
          console.log(
            "ADP address is Brantford, logging in with contact+brantford@",
          );
          setUsername("contact+brantford@truehearinghealth.com");
          setPassword("a4UbZyvjh%YQM6*5");
          field.children[2].value = "2023677";
        }
        if (field.children[8].value.includes("Milton")) {
          console.log("ADP address is Milton, logging in with contact+Milton@");
          setUsername("contact+milton@truehearinghealth.com");
          setPassword("Gr6@X$i9GaZ#2qE3");
          field.children[2].value = "2024778";
        }
      }
      setXMLDetails((prevState) => ({
        ...prevState,
        ADPportion: ADPportion,
      }));

      return null;
    });

    const hcvPayload = {
      applicantFirstname: parsedDetails.applicantFirstname ?? "",
      applicantLastname: parsedDetails.applicantLastname ?? "",
      date_of_birth: parsedDetails.date_of_birth ?? "",
      healthNumber: parsedDetails.healthNumber ?? "",
      versionCode: parsedDetails.versionCode ?? "",
    };

    console.log(
      "[ADPChecker] HCV payload prepared from XML upload",
      hcvPayload,
    );
    setHcvStatus("Validating health card...");
    validateHealthCardWithHcv(hcvPayload);

    sigCol.map((sig) => {
      let sigDate = Date.parse(sig.date);
      let dateDiff = Date.now() - sigDate;
      let dateDiffDays = dateDiff / (1000 * 60 * 60 * 24);

      if (isNaN(sigDate) || sigDate < 0) {
        setHasError((hasError) => [
          ...hasError,
          `${sig.name} does not have a valid date on page ${sig.page}.`,
        ]);
      } else if (dateDiffDays >= 365) {
        setHasError((hasError) => [
          ...hasError,
          `${sig.name} date is more than 1 year in the past on page ${sig.page}.`,
        ]);
      }
      return null;
    });

    //check signature order (robust to missing/invalid entries)
    const getParsedSigDate = (label) => {
      const entry = sigCol.find((sig) => sig.name === label);
      if (!entry || !entry.date) return null;
      const ts = Date.parse(entry.date);
      return isNaN(ts) ? null : ts;
    };

    const patientSigDateOne = getParsedSigDate("1st Patient signature");
    const patientSigDateTwo = getParsedSigDate("2nd Patient signature");
    const providerSig = getParsedSigDate("Clinician signature");
    // const doctorSig = getParsedSigDate("Doctor signature");
    const vendorSig = getParsedSigDate("Vendor signature");
    // console.log("doctorSig: " + doctorSig);
    console.log("patientSigDateTwo: " + patientSigDateTwo);

    //check signature order
    //patient 1st sig after patient 2nd sig
    if (
      patientSigDateOne !== null &&
      patientSigDateTwo !== null &&
      patientSigDateOne > patientSigDateTwo
    ) {
      setHasError((hasError) => [
        ...hasError,
        `Patient 1st signature cannot be after patient 2nd signature.`,
      ]);
    }
    //patient 1st sig after doctorSig
    // if (patientSigDateOne > doctorSig) {
    //   setHasError((hasError) => [
    //     ...hasError,
    //     `Patient 1st signature should be before doctor's signature.`,
    //   ]);
    // }
    // if (patientSigDateTwo < doctorSig) {
    //   setHasError((hasError) => [
    //     ...hasError,
    //     `Patient final signature should be after doctor's signature.`,
    //   ]);
    // }
    //patient 1st sig after vendorSig
    if (
      patientSigDateOne !== null &&
      vendorSig !== null &&
      patientSigDateOne > vendorSig
    ) {
      setHasError((hasError) => [
        ...hasError,
        `Patient 1st signature cannot be after THH's signature.`,
      ]);
    }
    //doctorSig after
    // if (doctorSig < providerSig) {
    //   setHasError((hasError) => [
    //     ...hasError,
    //     `Doctor signature should be on or after clinician's signature.`,
    //   ]);
    // }

    // Check authorizer date vs proof of delivery date
    // Proof of delivery must be after authorizer date and within 6 months
    if (providerSig !== null && patientSigDateTwo !== null) {
      // Proof of delivery date must be on or after authorizer date
      if (patientSigDateTwo < providerSig) {
        setHasError((hasError) => [
          ...hasError,
          `Proof of Delivery date cannot be before the Authorizer (Clinician) signature date.`,
        ]);
      }
      // Check if more than 6 months between authorizer date and proof of delivery date
      const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000; // approximately 6 months
      const diffBetweenDates = patientSigDateTwo - providerSig;
      if (diffBetweenDates > sixMonthsInMs) {
        setHasError((hasError) => [
          ...hasError,
          `Proof of Delivery date is more than 6 months after the Authorizer (Clinician) signature date.`,
        ]);
      }
    }

    // Check for valid audiogram on authorizer date
    // The audiogram must exist on the same date as the authorizer signature
    // and at least one ear must be tested (not both 'Not tested')
    if (providerSig !== null && parsedDetails.healthNumber) {
      const authorizerDateStr = new Date(providerSig)
        .toISOString()
        .split("T")[0]; // YYYY-MM-DD format
      const healthNumberPrefix = parsedDetails.healthNumber.substring(0, 10);

      console.log("[Audiogram Debug] All audiogram data:", audiogramData);
      console.log(
        "[Audiogram Debug] audiogramData length:",
        audiogramData.length,
      );
      console.log(
        "[Audiogram Debug] Looking for healthNumberPrefix:",
        healthNumberPrefix,
      );
      console.log(
        "[Audiogram Debug] Looking for authorizerDateStr:",
        authorizerDateStr,
      );

      // Log candidates for the authorizer date to help debugging
      const _candidates = audiogramData.filter((r) => r.entry_date === authorizerDateStr);
      console.log("[Audiogram Debug] date candidates count:", _candidates.length);
      console.log(
        "[Audiogram Debug] date candidates sample (hc, date):",
        _candidates.slice(0, 10).map((r) => ({ hc: r.health_card_no, date: r.entry_date })),
      );

      // Find matching audiogram record
      const matchingAudiogram = audiogramData.find((record) => {
        const healthCardMatches =
          record.health_card_no &&
          record.health_card_no.startsWith(healthNumberPrefix);
        const dateMatches = record.entry_date === authorizerDateStr;
        console.log("[Audiogram Debug] Checking record:", record);
        console.log(
          "[Audiogram Debug] record.health_card_no:",
          record.health_card_no,
          "healthCardMatches:",
          healthCardMatches,
        );
        console.log(
          "[Audiogram Debug] record.entry_date:",
          record.entry_date,
          "dateMatches:",
          dateMatches,
        );
        return healthCardMatches && dateMatches;
      });

      console.log("[Audiogram Debug] matchingAudiogram:", matchingAudiogram);

      if (!matchingAudiogram) {
        setHasError((hasError) => [
          ...hasError,
          `No audiogram found on the assessment date (${authorizerDateStr}). An audiogram must exist on the same date.`,
        ]);
      } else {
        // Check that at least one ear is tested
        const leftNotTested =
          matchingAudiogram.severity_desc_left === "Not tested";
        const rightNotTested =
          matchingAudiogram.severity_desc_right === "Not tested";

        if (leftNotTested && rightNotTested) {
          setHasError((hasError) => [
            ...hasError,
            `Audiogram on ${authorizerDateStr} has both ears marked as "Not tested". At least one ear must be tested.`,
          ]);
        }
      }
    }

    setParsingFile(false);
  };

  const handleFileChosen = (file) => {
    setParsingFile(true);
    setFileName("");
    setSubmitResult("");
    setFile(file);
    setHasError([]);
    setFirstRun(true);
    setHcvStatus("");
    setHcvDetails(null);
    setXMLDetails({});
    setFileName(file.name);
    fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsText(file);
    console.log("Reading file:", file.name);
  };
  const [siteDataContext] = useSiteDataApi();

  const validateHealthCardWithHcv = async (detailsOverride = {}) => {
    const details = {
      ...XMLDetails,
      ...detailsOverride,
    };

    const healthNumber = (details?.healthNumber || "").replace(/\D/g, "");
    const versionCode = (details?.versionCode || "").trim().toUpperCase();
    const firstName = details?.applicantFirstname || "";
    const lastName = details?.applicantLastname || "";
    const dateOfBirth = details?.date_of_birth || "";

    console.log("[HCV] Starting validation", {
      healthNumber,
      versionCode,
      firstName,
      lastName,
      dateOfBirth,
    });

    if (!healthNumber || healthNumber.length !== 10 || !versionCode) {
      const warning =
        "⚠️ Health card number or version code missing in XML. Unable to validate.";
      setHcvDetails(null);
      setHcvStatus(warning);
      console.warn("[HCV] Skipping validation due to missing data", {
        healthNumber,
        versionCode,
      });
      return { ok: false, reason: "missing" };
    }

    const payload = {
      healthNumber,
      versionCode,
      firstName,
      lastName,
      dateOfBirth,
    };

    try {
      const response = await fetch("/api/hcv/validate", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": siteDataContext.thhcsfrtoken,
        },
        body: JSON.stringify(payload),
      });

      let data = null;
      try {
        data = await response.json();
      } catch (parseError) {
        console.error("Unable to parse HCV response", parseError);
      }

      if (data) {
        setHcvDetails(data);
      } else {
        setHcvDetails(null);
      }

      // Check if the fault message indicates validation actually passed (despite ok=false)
      const faultMessage = data?.fault?.message || "";
      const validationPassed = faultMessage
        .toLowerCase()
        .includes("passed validation");

      if (response.ok && (data?.ok || validationPassed)) {
        const auditLabel = data.auditUID ? ` (Audit ${data.auditUID})` : "";

        if (validationPassed) {
          // Validation passed but with a warning/notice
          setHcvStatus(`✅ ${faultMessage}`);
        } else if (data?.fault?.message) {
          // Validation succeeded but has some other fault message
          setHcvStatus(
            `✅ Health card validated${auditLabel}. Note: ${faultMessage}`,
          );
        } else {
          // Clean success
          setHcvStatus(`✅ Health card validated${auditLabel}.`);
        }
        console.group("[HCV] Validation success");
        console.log("Payload", payload);
        console.log("Result", data);
        console.groupEnd();
        return { ok: true, data };
      }

      // True validation failure
      const errorMessage = faultMessage || "Health card validation failed.";
      setHcvStatus(`❌ ${errorMessage}`);
      console.group("[HCV] Validation failed");
      console.log("Payload", payload);
      console.log("Result", data);
      console.groupEnd();
      return { ok: false, data };
    } catch (error) {
      console.error("Error validating health card", error);
      setHcvDetails(null);
      setHcvStatus("❌ Unable to reach HCV validation service.");
      return { ok: false, error };
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!XMLFile || !file) {
      setSubmitResult("Please upload an XML file before submitting.");
      return;
    }

    // Show BP documents confirmation modal before submitting
    pendingSubmitEvent.current = true;
    setBpConfirmOpen(true);
  };

  const handleBpConfirmSubmit = async () => {
    // Close modal and reset checkboxes
    setBpConfirmOpen(false);
    setBpAttestationChecked(false);
    setBpApplicationChecked(false);
    pendingSubmitEvent.current = null;

    // Proceed with actual ADP submission

    const expectedFileName =
      XMLDetails?.applicantFirstname &&
      XMLDetails?.applicantLastname &&
      XMLDetails?.invoiceNo
        ? `${XMLDetails.applicantFirstname}_${XMLDetails.applicantLastname}_${XMLDetails.invoiceNo}.xml`
        : null;

    if (expectedFileName && fileName !== expectedFileName) {
      setRenameWarning(
        `Warning only: Filename has been renamed from '${fileName}' to ${expectedFileName} for submission.`,
      );
    } else {
      setRenameWarning(null);
    }

    setSubmitResult("Validating health card...");
    setHcvStatus("Validating health card...");
    const hcvOutcome = await validateHealthCardWithHcv();

    if (!hcvOutcome.ok) {
      if (hcvOutcome.reason === "missing") {
        setSubmitResult(
          "Health card validation could not start. Please ensure the XML includes the card number and version code.",
        );
      } else if (hcvOutcome?.data?.fault?.message) {
        setSubmitResult(
          `Health card validation failed: ${hcvOutcome.data.fault.message}`,
        );
      } else {
        setSubmitResult(
          "Health card validation failed. Review the details above and try again.",
        );
      }
      return;
    }

    setSubmitResult("Submitting to ADP...");

    const niceObject = {
      xmlString: XMLFile,
      fileName: file.name,
      username,
      password,
      applicantFirstname: XMLDetails.applicantFirstname,
      applicantLastname: XMLDetails.applicantLastname,
      invoiceNo: XMLDetails.invoiceNo,
      date_of_birth: XMLDetails.date_of_birth,
      phone: XMLDetails.phone,
      healthcard_four: XMLDetails.healthcard_four,
      ADPportion: XMLDetails.ADPportion,
      healthNumber: XMLDetails.healthNumber,
      versionCode: XMLDetails.versionCode,
    };

    try {
      const res = await fetch("/api/ADP-submit", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": siteDataContext.thhcsfrtoken,
        },
        body: JSON.stringify(niceObject),
      });

      const adpResponseData = await res.json();

      if (adpResponseData) {
        setRenameWarning(null);
        console.log("got adpResponseData", adpResponseData);
        setSubmitResult(adpResponseData);
      }
    } catch (error) {
      setRenameWarning(null);
      console.log("error submitting ADP", error);
      setSubmitResult("Error submitting ADP, please submit manually.");
    }
  };

  const [ADPsubmissiondata, setADPsubmissiondata] = useState([]);
  const [ADPstatusdata, setADPstatusdata] = useState([]);
  const [ADPesubmissiondata, setADPesubmissiondata] = useState([]);
  const [ADPeditHistory, setADPeditHistory] = useState([]);
  const [ADPreturnDetails, setADPreturnDetails] = useState();

  /**
   * Extract the ADP-known invoice number and claim number from extraStatus.
   * Blueprint's invoice_number may differ from what ADP actually accepted/paid.
   * The correct values live in _adp_status entries (extraStatus array).
   *
   * Priority: paid entry (has payment_amount) > approved/pending > any with invoice_number
   */
  const getADPInvoiceInfo = (extraStatus) => {
    if (!extraStatus || !extraStatus.length) return {};

    // Look for a paid entry (has payment_amount)
    let bestEntry = extraStatus.find(
      (s) => s.payment_amount && parseFloat(s.payment_amount) > 0,
    );

    // Fall back to "Payment Pending" or "Approved" status
    if (!bestEntry) {
      bestEntry = extraStatus.find(
        (s) =>
          s.adpStatus &&
          (s.adpStatus.includes("Payment Pending") ||
            s.adpStatus.includes("Approved")),
      );
    }

    // Fall back to any entry with an invoice_number (excluding Submission/Edit entries)
    if (!bestEntry) {
      bestEntry = extraStatus.find(
        (s) =>
          s.invoice_number &&
          s.adpStatus &&
          !s.adpStatus.includes("Submission") &&
          !s.adpStatus.includes("Edit"),
      );
    }

    if (bestEntry) {
      console.log("[getADPInvoiceInfo] Found ADP entry:", {
        adp_invoice_number: bestEntry.invoice_number,
        adp_claim_number: bestEntry.claim_number,
        adpStatus: bestEntry.adpStatus,
        payment_amount: bestEntry.payment_amount,
      });
      return {
        adp_invoice_number: bestEntry.invoice_number || "",
        adp_claim_number: bestEntry.claim_number || "",
      };
    }

    console.log(
      "[getADPInvoiceInfo] No matching ADP entry found in extraStatus:",
      extraStatus.map((s) => ({
        status: s.adpStatus,
        invoice: s.invoice_number,
        claim: s.claim_number,
      })),
    );
    return {};
  };

  const [ADPBPdata, setADPBPdata] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await fetchADPdata();
    }
    fetchData();
  }, [submitResult]);

  const fetchADPdata = async () => {
    try {
      // Fetch local ADP data
      const res = await fetch("/api/get-adp-data", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": siteDataContext.thhcsfrtoken,
        },
      });

      const data = await res.json();

      if (data) {
        console.log("[fetchADPdata] Local ADP data:", data);
        console.log("[fetchADPdata] ADPeditData raw:", data.ADPeditData);
        console.log("[fetchADPdata] ADPeditData[0]:", data.ADPeditData?.[0]);
        console.log(
          "[fetchADPdata] ADPstatusData count:",
          data.ADPstatusData?.[0]?.length,
        );
        // Log any Edit status entries
        const editStatuses = (data.ADPstatusData?.[0] || []).filter(
          (s) => s.adpStatus && s.adpStatus.includes("Edit"),
        );
        console.log(
          "[fetchADPdata] Edit status entries in _adp_status:",
          editStatuses,
        );
        setADPsubmissiondata(data.ADPsubmissionData?.[0] || []);
        setADPesubmissiondata(data.ADPesubmissionData?.[0] || []);
        setADPstatusdata(data.ADPstatusData?.[0] || []);
        setADPeditHistory(data.ADPeditData?.[0] || []);
      }

      // Fetch audiogram data from secure server
      const secureRes = await fetch("/api/get-adp-bp-data", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": siteDataContext.thhcsfrtoken,
        },
      });

      const secureData = await secureRes.json();
      console.log("[fetchADPdata] Secure server data:", secureData);
      console.log(
        "[fetchADPdata] audiogramData (raw sample):",
        secureData?.returnData?.audiogramData?.slice?.(0, 10),
      );
      const _audiogramData = secureData?.returnData?.audiogramData || [];
      console.log("[fetchADPdata] audiogramData count:", _audiogramData.length);
      // show a compact sample (health_card_no, entry_date) for quick inspection
      console.log(
        "[fetchADPdata] audiogramData sample (hc, date):",
        _audiogramData.slice(0, 10).map((r) => ({ hc: r.health_card_no, date: r.entry_date })),
      );
      setAudiogramData(_audiogramData);
    } catch (error) {
      console.log("error fetching get-adp-data", error);
    }
  };

  useEffect(() => {
    // Only run if ADPstatusdata has actual data and we haven't fetched yet
    if (
      !ADPstatusdata ||
      ADPstatusdata.length === 0 ||
      hasFetchedBPData.current
    ) {
      return;
    }

    console.log("getting further data");
    hasFetchedBPData.current = true; // Mark as fetched

    const timeoutId = setTimeout(() => {
      getFurtherData();
    }, 2000);

    // Cleanup function to cancel timeout if effect runs again
    return () => clearTimeout(timeoutId);
  }, [ADPstatusdata]);

  const getFurtherData = async () => {
    // GET DATA FROM INSECURE SERVER
    try {
      const res = await fetch("/api/get-adp-bp-data", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": siteDataContext.thhcsfrtoken,
        },
      });

      const adpBPdata = await res.json();

      if (adpBPdata) {
        // console.log('get-adp-bp-data', adpBPdata);
        // console.log('ADPstatusdata', ADPstatusdata);
        let ADPdata = adpBPdata.returnData[0];

        // Pre-build lookup Maps for O(1) access instead of O(n) nested loops
        // Group status data by combinedName and combinedNameHC
        const statusByName = new Map();
        const statusByNameHC = new Map();
        ADPstatusdata.forEach((status) => {
          const { client_ref, dateADP, healthcardFour } = status;
          const niceDate = new Date(Date.parse(dateADP));
          status.dateADP = niceDate;

          if (healthcardFour) {
            const key = client_ref + healthcardFour;
            if (status.adpStatus && status.adpStatus.includes("Edit")) {
              console.log("[statusByNameHC] Edit status entry:", {
                key,
                adpStatus: status.adpStatus,
                healthcardFour,
                client_ref,
                dateADP: niceDate,
              });
            }
            if (!statusByNameHC.has(key)) statusByNameHC.set(key, []);
            statusByNameHC.get(key).push(status);
          } else {
            if (!statusByName.has(client_ref)) statusByName.set(client_ref, []);
            statusByName.get(client_ref).push(status);
          }
        });

        // Group esubmission data by computed client ref
        const esubmissionByName = new Map();
        ADPesubmissiondata.forEach((status) => {
          const { adpStatus, filename, reportDate, adpReason } = status;
          if (typeof filename.split("_")[1] !== "undefined") {
            const computedClientRef =
              filename
                .split("_")[0]
                .toUpperCase()
                .replace(`'`, "")
                .substring(0, 2) +
              filename
                .split("_")[1]
                .toUpperCase()
                .replace(`'`, "")
                .substring(0, 2);
            const niceDate = new Date(Date.parse(reportDate));
            status.dateADP = niceDate;
            status.computedClientRef = computedClientRef;
            if (!esubmissionByName.has(computedClientRef))
              esubmissionByName.set(computedClientRef, []);
            esubmissionByName.get(computedClientRef).push(status);
          }
        });

        // Group submission data by computed client ref
        const submissionByName = new Map();
        ADPsubmissiondata.forEach((status) => {
          const { first_name, datesubmitted, last_name } = status;
          const computedClientRef =
            first_name.toUpperCase().replace(`'`, "").substring(0, 2) +
            last_name.toUpperCase().replace(`'`, "").substring(0, 2);
          const niceDate = new Date(Date.parse(datesubmitted));
          status.dateADP = niceDate;
          status.computedClientRef = computedClientRef;
          if (!submissionByName.has(computedClientRef))
            submissionByName.set(computedClientRef, []);
          submissionByName.get(computedClientRef).push(status);
        });

        ADPdata = ADPdata.map((row) => {
          let { first_name, last_name, healthcard_four } = row;
          let niceDate = Date.parse(row.delivery_time);
          niceDate = new Date(niceDate);
          row.delivery_time = niceDate;
          let compareDate = niceDate;
          let combinedName = "";
          let combinedNameHC = "";
          if (first_name && last_name) {
            combinedName =
              first_name.toUpperCase().replace(`'`, "").substring(0, 2) +
              last_name.toUpperCase().replace(`'`, "").substring(0, 2);
          }
          if (first_name && last_name && healthcard_four) {
            combinedNameHC =
              first_name.toUpperCase().replace(`'`, "").substring(0, 2) +
              last_name.toUpperCase().replace(`'`, "").substring(0, 2) +
              healthcard_four;
          }

          row.extraStatus = [];

          // Status data - O(1) lookup instead of O(n)
          const matchingStatusHC = statusByNameHC.get(combinedNameHC) || [];
          if (combinedNameHC.startsWith("FRBO")) {
            console.log("[extraStatus] FRBO patient:", {
              combinedNameHC,
              matchingStatusHC: matchingStatusHC.length,
              compareDate,
              first_name,
              last_name,
              healthcard_four,
            });
            matchingStatusHC.forEach((s) =>
              console.log("[extraStatus] FRBO status:", {
                adpStatus: s.adpStatus,
                dateADP: s.dateADP,
                passesFilter: compareDate <= s.dateADP,
              }),
            );
          }
          matchingStatusHC.forEach((status) => {
            if (compareDate <= status.dateADP) {
              row.extraStatus.push(status);
            }
          });
          const matchingStatus = statusByName.get(combinedName) || [];
          matchingStatus.forEach((status) => {
            if (compareDate <= status.dateADP) {
              row.extraStatus.push(status);
            }
          });

          // Esubmission data - O(1) lookup
          const matchingEsub = esubmissionByName.get(combinedName) || [];
          matchingEsub.forEach((status) => {
            if (compareDate <= status.dateADP) {
              status.adpStatus =
                "Submission -> " + status.adpStatus + " - " + status.adpReason;
              row.extraStatus.push(status);
            }
          });

          // THH website submission data - O(1) lookup
          const matchingSub = submissionByName.get(combinedName) || [];
          matchingSub.forEach((status) => {
            status.adpStatus = "Submitted from THH website";
            row.extraStatus.push(status);
          });

          if (row.extraStatus) {
            row.extraStatus = row.extraStatus.sortBy(function (o) {
              return o.dateADP;
            });
            row.extraStatus.reverse();
          }

          return row;
        });
        console.log("chad", ADPdata);
        //start sorting blueprint data by location and paid status
        const grouped = groupBy(ADPdata, (adp_patient) => adp_patient.location);
        let adpDataSortedByLocation = Array.from(grouped);
        adpDataSortedByLocation = adpDataSortedByLocation.map((location) => {
          let mapOne = groupBy(
            location[1],
            (adp_patient) => adp_patient.adp_balance,
          );
          let arrayOne = Array.from(mapOne);
          location[1] = arrayOne;
          // console.log('location', location[1][0]);
          if (location[1][0][0] === "Paid") location[1].reverse();
          return location;
        });
        // console.log('blueprint data sorted by clinic and paid status: ', adpDataSortedByLocation);

        setADPBPdata(adpDataSortedByLocation);
      }
    } catch (error) {
      console.log("error fetching get-adp-bp-data", error);
    }
  };

  return (
    <Box m={3} className="ADPpage">
      <Box className="xmluploader">
        {parsingFile ? (
          <Box>
            <Grid
              container
              spacing={0}
              direction="column"
              style={{ padding: "20px", minHeight: "100px" }}
            >
              <Grid item xs={3}>
                <CircularProgress />
                <br />
                <Typography>Validating XML file...</Typography>
              </Grid>
            </Grid>
          </Box>
        ) : null}
        {firstRun ? (
          <FileUploader
            multiple={false}
            fileOrFiles={null}
            onTypeError={(err) => alert(err)}
            handleChange={(file) => {
              handleFileChosen(file);
            }}
            name="file"
            types={fileTypes}
          />
        ) : (
          <Box>
            <FileUploader
              multiple={false}
              onTypeError={(err) => alert(err)}
              // handleChange={handleChange}
              handleChange={(file) => {
                handleFileChosen(file);
              }}
              name="file"
              types={fileTypes}
            />
            <Box mt={4} mb={4}>
              <Typography component="h5" variant="h5">
                Validation for {fileName}
              </Typography>
            </Box>
            {renameWarning ? (
              <Typography
                style={{ color: "#ffb263" }}
              >{`Warning only: Filename will be renamed from '${fileName}' to ${
                XMLDetails.applicantFirstname +
                "_" +
                XMLDetails.applicantLastname +
                "_" +
                XMLDetails.invoiceNo +
                ".xml"
              } for submission.`}</Typography>
            ) : null}
            {!hasError.length ? (
              <Typography>
                This appears to be a valid submission. If this is a
                resubmission, please make sure you changed the invoice#.
              </Typography>
            ) : null}
            <ul>
              {hasError.map((error, i) => {
                return (
                  <li key={i}>
                    <Typography>{error}</Typography>
                  </li>
                );
              })}
            </ul>
            <Box mt={6}>
              <Grid container spacing={1}>
                <Grid
                  container
                  sm={4}
                  spacing={1}
                  flexDirection="column"
                  item
                  style={{
                    border: "1px solid",
                    borderRadius: "4px",
                  }}
                >
                  <form autoComplete="on" onSubmit={handleSubmit}>
                    <Grid item container justifyContent="space-between">
                      <Grid item>
                        <Typography>
                          Click the button below to submit to ADP.
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Box mb={2} m={1} display="flex" flexDirection="column">
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={
                            hasError.length > 0 &&
                            !(
                              ctrlKeyHeld &&
                              adminUsers.includes(cookies.get("username"))
                            )
                          }
                          color={
                            hasError.length > 0 &&
                            !(
                              ctrlKeyHeld &&
                              adminUsers.includes(cookies.get("username"))
                            )
                              ? "inherit"
                              : "primary"
                          }
                          sx={{
                            ...(hasError.length > 0 &&
                              !(
                                ctrlKeyHeld &&
                                adminUsers.includes(cookies.get("username"))
                              ) && {
                                backgroundColor: "#9e9e9e !important",
                                color: "#666666 !important",
                                cursor: "not-allowed !important",
                                pointerEvents: "auto",
                              }),
                          }}
                        >
                          Automatic ADP Submission
                        </Button>
                        {hasError.length > 0 && (
                          <Typography
                            variant="body2"
                            color={
                              ctrlKeyHeld &&
                              adminUsers.includes(cookies.get("username"))
                                ? "warning.main"
                                : "error"
                            }
                            sx={{ mt: 1, fontWeight: "bold" }}
                          >
                            {ctrlKeyHeld &&
                            adminUsers.includes(cookies.get("username"))
                              ? "Admin override active - errors will be ignored."
                              : "Please fix errors above to submit."}
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                    <Grid
                      item
                      justifyContent="center"
                      alignItems="center"
                      style={{ padding: "10px" }}
                    >
                      {submitResult === "Submitting to ADP..." ||
                      submitResult === "Validating health card..." ? (
                        <div style={{ textAlign: "center" }}>
                          <CircularProgress />
                          <br />
                          {submitResult}
                        </div>
                      ) : submitResult ? (
                        <Alert severity={getSubmitSeverity(submitResult)}>
                          {submitResult}
                        </Alert>
                      ) : null}
                      {hcvStatus ? (
                        <Box mt={2} width="100%">
                          <Alert severity={getHcvSeverity(hcvStatus)}>
                            {hcvStatus}
                          </Alert>
                          {hcvDetails ? (
                            <Paper
                              variant="outlined"
                              sx={{ mt: 2, p: 2, backgroundColor: "#fafafa" }}
                            >
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mb={2}
                              >
                                <Typography variant="subtitle2">
                                  Health Card Validation Comparison
                                </Typography>
                                {(() => {
                                  // Check if all fields match
                                  const allFieldsMatch = Object.keys(
                                    comparisonLabels,
                                  ).every((field) => {
                                    const expectedValue =
                                      buildExpectedValue(field);
                                    const actualValue = buildActualValue(field);
                                    const match = evaluateFieldMatch(
                                      field,
                                      expectedValue,
                                      actualValue,
                                    );
                                    return match !== false; // true or undefined is OK, false means mismatch
                                  });

                                  return allFieldsMatch ? (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      gap={0.5}
                                      sx={{ color: "success.main" }}
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{ fontWeight: 600 }}
                                      >
                                        ✓ All fields match
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      gap={0.5}
                                      sx={{ color: "error.main" }}
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{ fontWeight: 600 }}
                                      >
                                        ✗ Mismatch detected
                                      </Typography>
                                    </Box>
                                  );
                                })()}
                              </Box>

                              <Grid container spacing={2}>
                                {(() => {
                                  // Check if validation passed (either ok=true or fault message says "passed validation")
                                  const faultMessage =
                                    hcvDetails?.fault?.message || "";
                                  const validationPassed =
                                    hcvDetails.ok ||
                                    faultMessage
                                      .toLowerCase()
                                      .includes("passed validation");

                                  // Check if all fields match to determine card colors
                                  const allFieldsMatch = Object.keys(
                                    comparisonLabels,
                                  ).every((field) => {
                                    const expectedValue =
                                      buildExpectedValue(field);
                                    const actualValue = buildActualValue(field);
                                    const match = evaluateFieldMatch(
                                      field,
                                      expectedValue,
                                      actualValue,
                                    );
                                    return match !== false;
                                  });
                                  const cardBgColor = allFieldsMatch
                                    ? "#e8f5e9"
                                    : "#ffebee";
                                  const cardBorderColor = allFieldsMatch
                                    ? "#4caf50"
                                    : "#f44336";
                                  const cardTextColor = allFieldsMatch
                                    ? "#2e7d32"
                                    : "#c62828";

                                  return (
                                    <>
                                      <Grid item xs={6}>
                                        <Paper
                                          sx={{
                                            p: 2,
                                            backgroundColor: cardBgColor,
                                            border: `1px solid ${cardBorderColor}`,
                                          }}
                                        >
                                          <Typography
                                            variant="subtitle2"
                                            gutterBottom
                                            sx={{
                                              fontWeight: 700,
                                              color: cardTextColor,
                                            }}
                                          >
                                            XML File
                                          </Typography>
                                          {Object.keys(comparisonLabels).map(
                                            (field) => {
                                              const expectedValue =
                                                buildExpectedValue(field);
                                              const actualValue =
                                                buildActualValue(field);
                                              const match = evaluateFieldMatch(
                                                field,
                                                expectedValue,
                                                actualValue,
                                              );
                                              const showMismatch =
                                                match === false;

                                              return (
                                                <Box key={field} mb={1.5}>
                                                  <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    sx={{ display: "block" }}
                                                  >
                                                    {comparisonLabels[field]}
                                                  </Typography>
                                                  <Typography
                                                    variant="body2"
                                                    sx={{
                                                      fontWeight: 600,
                                                      color: showMismatch
                                                        ? "error.main"
                                                        : "text.primary",
                                                      backgroundColor:
                                                        showMismatch
                                                          ? "#ffebee"
                                                          : "transparent",
                                                      padding: showMismatch
                                                        ? "2px 4px"
                                                        : 0,
                                                      borderRadius: showMismatch
                                                        ? "4px"
                                                        : 0,
                                                    }}
                                                  >
                                                    {expectedValue || "n/a"}
                                                  </Typography>
                                                </Box>
                                              );
                                            },
                                          )}
                                        </Paper>
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Paper
                                          sx={{
                                            p: 2,
                                            backgroundColor: cardBgColor,
                                            border: `1px solid ${cardBorderColor}`,
                                            position: "relative",
                                          }}
                                        >
                                          <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            mb={1}
                                          >
                                            <Typography
                                              variant="subtitle2"
                                              sx={{
                                                fontWeight: 700,
                                                color: cardTextColor,
                                              }}
                                            >
                                              Ministry of Health
                                            </Typography>
                                            {validationPassed ? (
                                              <Box
                                                sx={{
                                                  backgroundColor: "#4caf50",
                                                  color: "white",
                                                  px: 1,
                                                  py: 0.5,
                                                  borderRadius: 1,
                                                  fontSize: "0.75rem",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                ✓ Validated
                                              </Box>
                                            ) : (
                                              <Box
                                                sx={{
                                                  backgroundColor: "#f44336",
                                                  color: "white",
                                                  px: 1,
                                                  py: 0.5,
                                                  borderRadius: 1,
                                                  fontSize: "0.75rem",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                ✗ Failed
                                              </Box>
                                            )}
                                          </Box>
                                          {Object.keys(comparisonLabels).map(
                                            (field) => {
                                              const expectedValue =
                                                buildExpectedValue(field);
                                              const actualValue =
                                                buildActualValue(field);
                                              const match = evaluateFieldMatch(
                                                field,
                                                expectedValue,
                                                actualValue,
                                              );
                                              const showMismatch =
                                                match === false;

                                              return (
                                                <Box key={field} mb={1.5}>
                                                  <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    sx={{ display: "block" }}
                                                  >
                                                    {comparisonLabels[field]}
                                                  </Typography>
                                                  <Typography
                                                    variant="body2"
                                                    sx={{
                                                      fontWeight: 600,
                                                      color: showMismatch
                                                        ? "error.main"
                                                        : "text.primary",
                                                      backgroundColor:
                                                        showMismatch
                                                          ? "#ffcdd2"
                                                          : "transparent",
                                                      padding: showMismatch
                                                        ? "2px 4px"
                                                        : 0,
                                                      borderRadius: showMismatch
                                                        ? "4px"
                                                        : 0,
                                                    }}
                                                  >
                                                    {actualValue || "n/a"}
                                                  </Typography>
                                                </Box>
                                              );
                                            },
                                          )}
                                        </Paper>
                                      </Grid>
                                    </>
                                  );
                                })()}
                              </Grid>

                              {hcvDetails.result ? (
                                <Box
                                  mt={2}
                                  p={2}
                                  sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: 1,
                                    border: "1px solid #e0e0e0",
                                  }}
                                >
                                  <Typography variant="body2" gutterBottom>
                                    <strong>Response Code:</strong>{" "}
                                    {hcvDetails.result.responseCode ?? "0"}
                                  </Typography>
                                  {hcvDetails.result.responseDescription ? (
                                    <Box mt={1}>
                                      <Typography variant="body2" gutterBottom>
                                        <strong>Description:</strong>
                                      </Typography>
                                      {hcvDetails.result.responseDescription.includes(
                                        ";",
                                      ) ? (
                                        <ul
                                          style={{
                                            margin: "4px 0",
                                            paddingLeft: "1.25rem",
                                          }}
                                        >
                                          {hcvDetails.result.responseDescription
                                            .split(";")
                                            .map((item) => item.trim())
                                            .filter(Boolean)
                                            .map((item, idx) => (
                                              <li key={idx}>
                                                <Typography variant="body2">
                                                  {item}
                                                </Typography>
                                              </li>
                                            ))}
                                        </ul>
                                      ) : (
                                        <Typography variant="body2">
                                          {
                                            hcvDetails.result
                                              .responseDescription
                                          }
                                        </Typography>
                                      )}
                                    </Box>
                                  ) : null}
                                  {hcvDetails.result.expiryDate ? (
                                    <Typography variant="body2" mt={1}>
                                      <strong>Card Expiry:</strong>{" "}
                                      {normalizeDate(
                                        hcvDetails.result.expiryDate,
                                      )}
                                    </Typography>
                                  ) : null}
                                  {hcvDetails.result.versionCode ? (
                                    <Typography variant="body2">
                                      <strong>Version Code:</strong>{" "}
                                      {hcvDetails.result.versionCode}
                                    </Typography>
                                  ) : null}
                                  <Box mt={2}>
                                    <Button
                                      component="a"
                                      href={HEALTHCARD_CODES_URL}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      startIcon={<PictureAsPdfIcon />}
                                      variant="outlined"
                                      size="small"
                                    >
                                      View health card response codes (PDF)
                                    </Button>
                                  </Box>
                                </Box>
                              ) : null}
                            </Paper>
                          ) : null}
                        </Box>
                      ) : null}
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Box>

      {ADPBPdata &&
      ADPBPdata[0] &&
      ADPBPdata[0][1] &&
      ADPBPdata[0][1][0] &&
      ADPBPdata[0][1][0][1] &&
      ADPBPdata[0][1][0][1][0] &&
      ADPBPdata[0][1][0][1][0].extraStatus ? (
        <Box mt={7}>
          <AppBar position="static">
            <Tabs
              value={value}
              variant="fullWidth"
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              aria-label="fullwidth tabs"
            >
              {ADPBPdata.map((key, count) => {
                return (
                  <Tab
                    label={`${key[0]} (${key[1][0][1].length})`}
                    {...a11yProps(count)}
                    key={count}
                  />
                );
              })}
            </Tabs>
          </AppBar>
          {ADPBPdata.map((row, count) => {
            return (
              <TabPanel value={value} index={count} key={count}>
                {row[1].map((PaidStatus, y) => {
                  let groupedPaidStatus = PaidStatus[1];

                  let margin = 0;
                  if (PaidStatus[0] === "Paid") {
                    margin = 7;
                    groupedPaidStatus = groupedPaidStatus.reverse();
                  } else {
                    margin = 0;
                  }
                  return (
                    <Box mt={margin} key={y}>
                      <Typography component="h3" variant="h5">
                        {PaidStatus[0]} ADP Patients - {PaidStatus[1].length}
                      </Typography>
                      <TableContainer component={Paper}>
                        <Table
                          sx={{ minWidth: 650 }}
                          size="small"
                          aria-label="referral table"
                          className="referralTable"
                        >
                          <TableHead>
                            <StyledTableRow>
                              <StyledTableCell style={{ width: "15%" }}>
                                Treatment Start
                              </StyledTableCell>
                              <StyledTableCell style={{ width: "15%" }}>
                                Patient
                              </StyledTableCell>
                              <StyledTableCell style={{ width: "10%" }}>
                                Invoice #
                              </StyledTableCell>
                              <StyledTableCell style={{ width: "10%" }}>
                                ADP Amount
                              </StyledTableCell>
                              <StyledTableCell
                                style={{
                                  width:
                                    PaidStatus[0] === "Paid" ? "10%" : "40%",
                                }}
                              >
                                {PaidStatus[0] === "Paid"
                                  ? "ADP Paid"
                                  : "Extra Status"}
                              </StyledTableCell>
                              {adminUsers.includes(cookies.get("username")) ? (
                                <StyledTableCell style={{ width: "10%" }}>
                                  Edit
                                </StyledTableCell>
                              ) : null}
                            </StyledTableRow>
                          </TableHead>
                          <TableBody>
                            {groupedPaidStatus.map((ADPpatient, y) => {
                              const {
                                delivery_time,
                                date_of_birth,
                                invoice_number,
                                phone,
                                healthcard_four,
                                first_name,
                                last_name,
                                adp_amount,
                                adp_paid,
                                extraStatus,
                              } = ADPpatient;
                              return (
                                <StyledTableRow
                                  key={y}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell>
                                    <div
                                      className={
                                        delivery_time &&
                                        (new Date().getTime() - delivery_time) /
                                          (1000 * 3600 * 24) >
                                          90
                                          ? "fail"
                                          : ""
                                      }
                                    >
                                      {delivery_time.toLocaleString("en-US", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "numeric",
                                      })}
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    {" "}
                                    <Tooltip
                                      enterTouchDelay={0}
                                      leaveTouchDelay={0}
                                      title={
                                        <div>
                                          DOB: {date_of_birth}
                                          <br />
                                          Phone: {formatPhoneNumber(phone)}
                                          <br />
                                          Healthcard 4: {healthcard_four}
                                        </div>
                                      }
                                    >
                                      <div>{`${first_name} ${last_name}`}</div>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell>{invoice_number}</TableCell>
                                  <TableCell>
                                    {adp_amount
                                      ? `$${numberWithCommas(adp_amount)}`
                                      : null}
                                  </TableCell>
                                  <TableCell>
                                    <div
                                      className={
                                        extraStatus && extraStatus.length
                                          ? "extra"
                                          : "noextra"
                                      }
                                    >
                                      <div
                                        className={
                                          extraStatus &&
                                          extraStatus.length &&
                                          extraStatus[0].adpStatus.includes(
                                            "Fail",
                                          )
                                            ? "fail"
                                            : ""
                                        }
                                      >
                                        <div
                                          className={
                                            // prettier-ignore
                                            extraStatus && extraStatus.length && extraStatus[0].adpStatus.includes('Payment Pending') && !adp_paid
                                              ? 'paymentpending'
                                              : (extraStatus && extraStatus.length && (extraStatus[0].adpStatus.includes('Submission -> Accepted - Accepted') || (extraStatus[0].adpStatus.includes('In Process'))|| (extraStatus[0].adpStatus.includes('Approved'))) && (new Date().getTime() - extraStatus[0].dateADP) / (1000 * 3600 * 24) <= 21)
                                              ? `accepted`
                                              : extraStatus && extraStatus.length && (extraStatus[0].adpStatus.includes('Submission -> Accepted - Accepted') || (extraStatus[0].adpStatus.includes('In Process'))|| (extraStatus[0].adpStatus.includes('Approved'))) && (new Date().getTime() - extraStatus[0].dateADP) / (1000 * 3600 * 24) > 21
                                              ? 'fail' 
                                              : extraStatus && extraStatus.length && (extraStatus[0].adpStatus.includes('Submitted from THH website')&& (new Date().getTime() - extraStatus[0].dateADP) / (1000 * 3600 * 24) < 5) 
                                              ? 'accepted'
                                              : 'fail'
                                          }
                                        >
                                          {adp_paid &&
                                          extraStatus[0] &&
                                          extraStatus[0].adpStatus.includes(
                                            "Return",
                                          ) &&
                                          !extraStatus[0].adpStatus.includes(
                                            "Edit",
                                          ) ? (
                                            <div>
                                              {extraStatus[0].adpStatus +
                                                " on " +
                                                extraStatus[0].dateADP.toDateString() +
                                                " for $" +
                                                numberWithCommas(
                                                  extraStatus[0].payment_amount,
                                                )}
                                            </div>
                                          ) : adp_paid ? (
                                            <>
                                              <Grid
                                                container
                                                spacing={3}
                                                alignItems="center"
                                                justifyContent="space-between"
                                              >
                                                <Grid
                                                  item
                                                >{`$${numberWithCommas(
                                                  adp_paid,
                                                )}`}</Grid>
                                                <Grid item>
                                                  {adminUsers.includes(
                                                    cookies.get("username"),
                                                  ) ? (
                                                    <Button
                                                      variant="contained"
                                                      color="primary"
                                                      onClick={() => {
                                                        const adpInfo =
                                                          getADPInvoiceInfo(
                                                            extraStatus,
                                                          );
                                                        setADPreturnDetails(
                                                          {
                                                            amount: adp_paid,
                                                            patient: `${first_name} ${last_name}`,
                                                            date_of_birth,
                                                            invoice_number,
                                                            healthcard_four,
                                                            adp_invoice_number:
                                                              adpInfo.adp_invoice_number ||
                                                              "",
                                                            adp_claim_number:
                                                              adpInfo.adp_claim_number ||
                                                              "",
                                                          },
                                                          handleOpen(),
                                                        );
                                                      }}
                                                    >
                                                      Return
                                                    </Button>
                                                  ) : null}
                                                </Grid>
                                              </Grid>
                                              {/* Show edit history button for paid patients */}
                                              {extraStatus &&
                                                extraStatus.filter(
                                                  (s) =>
                                                    s.adpStatus &&
                                                    s.adpStatus.includes(
                                                      "Edit -",
                                                    ),
                                                ).length > 0 &&
                                                (() => {
                                                  const editDetail =
                                                    ADPeditHistory.length
                                                      ? ADPeditHistory.find(
                                                          (edit) =>
                                                            edit.healthcard_four ===
                                                            healthcard_four,
                                                        )
                                                      : null;
                                                  const editDate =
                                                    extraStatus.find(
                                                      (s) =>
                                                        s.adpStatus &&
                                                        s.adpStatus.includes(
                                                          "Edit -",
                                                        ),
                                                    )?.dateADP;
                                                  return (
                                                    <div
                                                      style={{ marginTop: 8 }}
                                                    >
                                                      <Button
                                                        variant="outlined"
                                                        size="small"
                                                        startIcon={
                                                          <HistoryIcon />
                                                        }
                                                        onClick={() => {
                                                          setEditHistoryDetail(
                                                            editDetail,
                                                          );
                                                          setEditHistoryOpen(
                                                            true,
                                                          );
                                                        }}
                                                        sx={{
                                                          textTransform: "none",
                                                        }}
                                                      >
                                                        Edit Submitted{" "}
                                                        {editDate
                                                          ? editDate.toLocaleDateString(
                                                              "en-US",
                                                            )
                                                          : ""}
                                                      </Button>
                                                    </div>
                                                  );
                                                })()}
                                            </>
                                          ) : extraStatus &&
                                            extraStatus.length ? (
                                            <div>
                                              <div>
                                                {/* Consolidated edit button (skip individual Edit - lines) */}
                                                {(() => {
                                                  const editStatuses =
                                                    ADPpatient.extraStatus.filter(
                                                      (s) =>
                                                        s.adpStatus &&
                                                        s.adpStatus.includes(
                                                          "Edit -",
                                                        ) &&
                                                        s.dateADP >
                                                          delivery_time,
                                                    );
                                                  if (editStatuses.length > 0) {
                                                    const editDetail =
                                                      ADPeditHistory.length
                                                        ? ADPeditHistory.find(
                                                            (edit) =>
                                                              edit.healthcard_four ===
                                                              healthcard_four,
                                                          )
                                                        : null;
                                                    const editDate =
                                                      editStatuses[0]?.dateADP;
                                                    return (
                                                      <div
                                                        style={{
                                                          marginBottom: 4,
                                                        }}
                                                      >
                                                        <Button
                                                          variant="outlined"
                                                          size="small"
                                                          startIcon={
                                                            <HistoryIcon />
                                                          }
                                                          onClick={() => {
                                                            setEditHistoryDetail(
                                                              editDetail,
                                                            );
                                                            setEditHistoryOpen(
                                                              true,
                                                            );
                                                          }}
                                                          sx={{
                                                            textTransform:
                                                              "none",
                                                          }}
                                                        >
                                                          Edit Submitted{" "}
                                                          {editDate
                                                            ? editDate.toLocaleDateString(
                                                                "en-US",
                                                              )
                                                            : ""}
                                                        </Button>
                                                      </div>
                                                    );
                                                  }
                                                  return null;
                                                })()}
                                                {ADPpatient.extraStatus
                                                  .filter(
                                                    (status) =>
                                                      !status.adpStatus ||
                                                      !status.adpStatus.includes(
                                                        "Edit -",
                                                      ),
                                                  )
                                                  .map((status, index) => {
                                                    return status.dateADP >
                                                      delivery_time ? (
                                                      <div key={index}>
                                                        <Typography
                                                          component="div"
                                                          style={{
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {status.dateADP.toLocaleString(
                                                            "en-US",
                                                            {
                                                              year: "numeric",
                                                              month: "2-digit",
                                                              day: "numeric",
                                                            },
                                                          )}{" "}
                                                          {` - `}
                                                          <Box
                                                            component="span"
                                                            style={{
                                                              fontWeight:
                                                                "normal",
                                                            }}
                                                          >
                                                            {status.adpStatus}
                                                          </Box>
                                                        </Typography>
                                                      </div>
                                                    ) : (
                                                      <div key={index}>
                                                        Not yet submitted?
                                                      </div>
                                                    );
                                                  })}
                                              </div>
                                            </div>
                                          ) : (
                                            <div>Not yet submitted?</div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </TableCell>
                                  {adminUsers.includes(
                                    cookies.get("username"),
                                  ) ? (
                                    <TableCell>
                                      <Button
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        onClick={() => {
                                          const adpInfo =
                                            getADPInvoiceInfo(extraStatus);
                                          setADPeditDetails({
                                            amount: adp_paid || adp_amount,
                                            patient: `${first_name} ${last_name}`,
                                            date_of_birth,
                                            invoice_number,
                                            healthcard_four,
                                            adp_invoice_number:
                                              adpInfo.adp_invoice_number || "",
                                            adp_claim_number:
                                              adpInfo.adp_claim_number || "",
                                          });
                                          setEditIsPaid(
                                            PaidStatus[0] === "Paid",
                                          );
                                          handleEditOpen();
                                        }}
                                      >
                                        Submit Edit
                                      </Button>
                                    </TableCell>
                                  ) : null}
                                </StyledTableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  );
                })}
              </TabPanel>
            );
          })}
          {ADPreturnDetails ? (
            <ReturnModal
              open={open}
              handleClose={handleClose}
              ADPreturnDetails={{ ADPreturnDetails }}
              username={username}
              password={password}
            />
          ) : null}
          {ADPeditDetails ? (
            <EditModal
              open={editOpen}
              handleClose={handleEditClose}
              editDetails={ADPeditDetails}
              isPaid={editIsPaid}
            />
          ) : null}
          {/* Edit History Modal */}
          <Dialog
            open={editHistoryOpen}
            onClose={() => setEditHistoryOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>Edit History</span>
              <IconButton
                onClick={() => setEditHistoryOpen(false)}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {editHistoryDetail &&
                (() => {
                  const originalVals = (() => {
                    try {
                      return typeof editHistoryDetail.original_values ===
                        "string"
                        ? JSON.parse(editHistoryDetail.original_values)
                        : editHistoryDetail.original_values || [];
                    } catch {
                      return [];
                    }
                  })();
                  const newVals = (() => {
                    try {
                      return typeof editHistoryDetail.new_values === "string"
                        ? JSON.parse(editHistoryDetail.new_values)
                        : editHistoryDetail.new_values || [];
                    } catch {
                      return [];
                    }
                  })();

                  const fieldLabels = {
                    invoiceNumber: "Invoice Number",
                    invoiceDate: "Invoice Date",
                    deliveryDate: "Delivery Date",
                    serviceStartDate: "Service Start Date",
                    serviceEndDate: "Service End Date",
                    deviceCode: "Device Code",
                    serialNumber: "Serial Number",
                    quantity: "Quantity",
                    unitPrice: "Unit Price",
                    adpPortion: "ADP Portion",
                    clientPortion: "Client Portion",
                    socialAssistanceCode: "Social Assistance Code",
                  };

                  // Normalize date strings for comparison
                  // DDMMYYYY (02022026) ↔ YYYY-MM-DD (2026-02-02) are the same
                  const normalizeDate = (val) => {
                    if (!val || val.length !== 8 || !/^\d{8}$/.test(val))
                      return val;
                    // DDMMYYYY → YYYY-MM-DD
                    return (
                      val.substring(4, 8) +
                      "-" +
                      val.substring(2, 4) +
                      "-" +
                      val.substring(0, 2)
                    );
                  };
                  const dateFields = [
                    "invoiceDate",
                    "deliveryDate",
                    "serviceStartDate",
                    "serviceEndDate",
                  ];

                  // Build per-device change lists
                  const deviceCount = Math.max(
                    originalVals.length,
                    newVals.length,
                  );
                  const devices = [];
                  for (let i = 0; i < deviceCount; i++) {
                    const orig = originalVals[i] || {};
                    const updated = newVals[i] || {};
                    const placement =
                      updated.placement ||
                      orig.placement ||
                      (i === 0 ? "L" : "R");
                    const changes = [];
                    Object.keys(fieldLabels).forEach((key) => {
                      let origVal = String(orig[key] || "");
                      let newVal = String(updated[key] || "");
                      // Normalize dates before comparing
                      if (dateFields.includes(key)) {
                        origVal = normalizeDate(origVal);
                        newVal = normalizeDate(newVal);
                      }
                      if (origVal !== newVal) {
                        changes.push({
                          key,
                          label: fieldLabels[key],
                          original: origVal,
                          updated: newVal,
                        });
                      }
                    });
                    devices.push({
                      placement:
                        placement === "L"
                          ? "Left"
                          : placement === "R"
                            ? "Right"
                            : placement,
                      changes,
                    });
                  }

                  return (
                    <div>
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Patient:</strong>{" "}
                            {editHistoryDetail.patient_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Edit Type:</strong>{" "}
                            {editHistoryDetail.edit_type ===
                            "return_and_resubmit"
                              ? "Return & Resubmit"
                              : "Resubmit Only"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Original Invoice:</strong>{" "}
                            {editHistoryDetail.invoice_number}
                          </Typography>
                        </Grid>
                        {editHistoryDetail.new_invoice_number !==
                          editHistoryDetail.invoice_number && (
                          <Grid item xs={6}>
                            <Typography variant="body2">
                              <strong>New Invoice:</strong>{" "}
                              {editHistoryDetail.new_invoice_number}
                            </Typography>
                          </Grid>
                        )}
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Claim Number:</strong>{" "}
                            {editHistoryDetail.claim_number}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Submitted:</strong>{" "}
                            {editHistoryDetail.dateSubmitted
                              ? new Date(
                                  editHistoryDetail.dateSubmitted,
                                ).toLocaleString()
                              : "N/A"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Filename:</strong>{" "}
                            <span>{editHistoryDetail.filename}</span>
                            <Button
                              size="small"
                              variant="text"
                              sx={{
                                ml: 1,
                                textTransform: "none",
                                minWidth: 0,
                                p: "2px 8px",
                                fontSize: "12px",
                              }}
                              onClick={() => {
                                try {
                                  // Reconstruct TXT from stored values
                                  const orig = (() => {
                                    try {
                                      return typeof editHistoryDetail.original_values ===
                                        "string"
                                        ? JSON.parse(
                                            editHistoryDetail.original_values,
                                          )
                                        : editHistoryDetail.original_values ||
                                            [];
                                    } catch {
                                      return [];
                                    }
                                  })();
                                  const edited = (() => {
                                    try {
                                      return typeof editHistoryDetail.new_values ===
                                        "string"
                                        ? JSON.parse(
                                            editHistoryDetail.new_values,
                                          )
                                        : editHistoryDetail.new_values || [];
                                    } catch {
                                      return [];
                                    }
                                  })();
                                  const fmtCurr = (v) => {
                                    const n = parseFloat(v);
                                    return isNaN(n) ? "0.00" : n.toFixed(2);
                                  };
                                  const fmtDate = (d) => {
                                    if (!d) return "";
                                    // Already DDMMYYYY
                                    if (/^\d{8}$/.test(d)) return d;
                                    // YYYY-MM-DD → DDMMYYYY
                                    if (/^\d{4}-\d{2}-\d{2}/.test(d))
                                      return (
                                        d.substring(8, 10) +
                                        d.substring(5, 7) +
                                        d.substring(0, 4)
                                      );
                                    return d;
                                  };
                                  const toRow = (f) =>
                                    [
                                      f.vendorNo,
                                      f.claimNo,
                                      f.healthcardFour,
                                      f.invoiceNumber,
                                      fmtDate(f.invoiceDate),
                                      fmtDate(f.deliveryDate),
                                      fmtDate(f.serviceStartDate),
                                      fmtDate(f.serviceEndDate),
                                      f.deviceCode,
                                      f.serialNumber,
                                      f.placement,
                                      f.quantity,
                                      fmtCurr(f.unitPrice),
                                      fmtCurr(f.adpPortion),
                                      fmtCurr(f.clientPortion),
                                      f.socialAssistanceCode || "",
                                    ].join(",");
                                  let lines = [];
                                  if (
                                    editHistoryDetail.edit_type ===
                                      "return_and_resubmit" &&
                                    orig.length
                                  ) {
                                    lines = [
                                      ...orig.map(toRow),
                                      ...edited.map(toRow),
                                    ];
                                  } else {
                                    lines = edited.map(toRow);
                                  }
                                  const txt = lines.join("\n");
                                  navigator.clipboard.writeText(txt);
                                  alert("TXT content copied to clipboard!");
                                } catch (e) {
                                  alert("Error building TXT: " + e.message);
                                }
                              }}
                            >
                              Copy TXT
                            </Button>
                          </Typography>
                        </Grid>
                      </Grid>

                      {devices.length > 0 &&
                      devices.some((d) => d.changes.length > 0) ? (
                        devices.map(
                          (device, dIdx) =>
                            device.changes.length > 0 && (
                              <div
                                key={dIdx}
                                style={{
                                  marginBottom:
                                    dIdx < devices.length - 1 ? 16 : 0,
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{ mb: 1, fontWeight: "bold" }}
                                >
                                  {devices.length > 1
                                    ? `${device.placement} Side — `
                                    : ""}
                                  Changed Fields:
                                </Typography>
                                <TableContainer
                                  component={Paper}
                                  variant="outlined"
                                >
                                  <Table size="small">
                                    <TableHead>
                                      <StyledTableRow>
                                        <StyledTableCell>Field</StyledTableCell>
                                        <StyledTableCell>
                                          Original Value
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          New Value
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                      {device.changes.map((field) => (
                                        <TableRow key={field.key}>
                                          <TableCell
                                            sx={{ fontWeight: "bold" }}
                                          >
                                            {field.label}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              color: "#d32f2f",
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            {field.original || "(empty)"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              color: "#2e7d32",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {field.updated || "(empty)"}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            ),
                        )
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No field changes detected (original values may not
                          have been recorded).
                        </Typography>
                      )}
                    </div>
                  );
                })()}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setEditHistoryOpen(false)}>Close</Button>
            </DialogActions>
          </Dialog>

          {/* BP Documents Confirmation Modal */}
          <Dialog
            open={bpConfirmOpen}
            onClose={() => {
              setBpConfirmOpen(false);
              setBpAttestationChecked(false);
              setBpApplicationChecked(false);
            }}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              Confirm Blueprint Documents
              <IconButton
                aria-label="close"
                onClick={() => {
                  setBpConfirmOpen(false);
                  setBpAttestationChecked(false);
                  setBpApplicationChecked(false);
                }}
                sx={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Typography sx={{ mb: 2 }}>
                Go to patient's Blueprint documents, confirm the following
                documents are on their file:
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={bpAttestationChecked}
                    onChange={(e) => setBpAttestationChecked(e.target.checked)}
                  />
                }
                label="Attestation Signed by Client + Provider"
              />
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={bpApplicationChecked}
                    onChange={(e) => setBpApplicationChecked(e.target.checked)}
                  />
                }
                label="ADP application signed by Client page 3+4"
              />
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                disabled={!bpAttestationChecked || !bpApplicationChecked}
                onClick={handleBpConfirmSubmit}
                sx={{
                  ...(!bpAttestationChecked || !bpApplicationChecked
                    ? {
                        backgroundColor: "#9e9e9e !important",
                        color: "#666666 !important",
                      }
                    : {}),
                }}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      ) : (
        <Box>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: "100vh" }}
          >
            <Grid item xs={3}>
              <CircularProgress
                style={{ display: "block", margin: "0 auto" }}
              />
              <br />
              <Typography style={{ textAlign: "center" }}>
                Loading data...
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default ADPTracker;
